import { render } from "./ObjectLabel.vue?vue&type=template&id=08b702c8"
import script from "./ObjectLabel.vue?vue&type=script&lang=js"
export * from "./ObjectLabel.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__